import {Trans, useTranslation} from 'react-i18next';
import {useScreenResize} from 'hooks';
import {device} from '@guestapp/ui/src/utils/device';
import {SDK_MODE} from '../../utils/embedded';
import Page from 'components/Page';
import {Content, LanguageSDKSwitcherStyled} from './styled';

function PrivacyPolicyView() {
  const {t} = useTranslation('privacy-policy');
  const {isMatch: isMobile} = useScreenResize(device.tabletSubHeader);

  return (
    <Page
      isSubHeaderVisible
      hideMenu={window.ChekinProSettings?.mode === SDK_MODE.onlyGuestForm}
      navBarTitle={t('privacy_policy')}
      className="privacy-policy-page"
      mainHeader={!isMobile}
      subheaderRightAddon={<LanguageSDKSwitcherStyled />}
    >
      <Content className="privacy-policy-page__content">
        <Trans i18nKey="generic_privacy_policy_accommodations" ns="privacy-policy" />
      </Content>
    </Page>
  );
}

export {PrivacyPolicyView};
